import { commonActions } from "../../redux/reducers/CommonReducer";
import store from "../../redux/Store";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import classes from "./Dashboard.module.css";

const Dashborad = () => {
  const currentUsersScopes = useSelector((state) => {
    return state.user?.currentUsersScopes;
  });

  useEffect(() => {
    if (currentUsersScopes?.length > 0) {
      store.dispatch(commonActions.setIsShowLoadingSpinner(false));
    }

  }, [currentUsersScopes]);

  return (
    <div className={classes.dashboardPage}>
      {/* <h1>Dashboard</h1> */}
      <iframe title="GMT PI - version_9" width="100%" height="100%"
      src="https://app.powerbi.com/reportEmbed?reportId=e9876a4b-fbe0-47cc-bd63-0f9aa7770f31&autoAuth=true&ctid=e924c287-5dc0-4f33-89a4-fbb08540eb7f"
      frameBorder="0" allowFullScreen={true} />
    </div>
  );
};

export default Dashborad;
